<template>
  <ConfirmDialog
    :value="visibility"
    :confirm-text="'送信'"
    :disabled="!file"
    :loading="confirmBtnLoading"
    :confirm-btn-color="'green darken-1'"
    @confirm="sendFileHandler"
    @cancel="csvUploadDialogCloseHandler"
    @input="csvUploadDialogCloseHandler"
  >
    <h2 class="dialogHeader">
      {{ dialogText }}
    </h2>
    <v-select
      v-if="company.id === 1"
      v-model="csvDialogCompany"
      label="会社"
      :items="csvDialogGroup"
    />
    <input
      id="fileInput"
      ref="file"
      type="file"
      accept=".csv"
      @change="onFileChanged"
    >
    <div
      v-if="errors.length"
      class="d-flex
                align-center
                justify-center
                pt-3
                error-header"
      @click="toggleErrorContainer"
    >
      <v-icon color="red">
        mdi-close
      </v-icon>

      エラーが発生しました。

      <v-icon
        color="grey"
        size="20"
        class="down-icon"
      >
        {{ hasError ? 'mdi-chevron-up-circle-outline' : 'mdi-chevron-down-circle-outline' }}
      </v-icon>
    </div>

    <div
      :class="{visible: processing}"
      class="processing"
    >
      取り込み可能か確認しています...
    </div>
    <div
      class="pa-1 error-container"
      :class="hasError ? 'error-container-toggled' : ''"
    >
      <ul>
        <li
          v-for="(error,i) in errors"
          :key="i"
        >
          {{ error.message }}
        </li>
      </ul>
    </div>
  </ConfirmDialog>
</template>
<script>
import { ConfirmDialog } from '@/components/dialog'
import { mapState, mapActions } from 'vuex'
import { api } from '@/api.js'

export default {
  components: {
    ConfirmDialog
  },
  props: {
    visibility: {
      type: Boolean,
      default: () => false
    },
    dialogText: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      file: null,
      csvDialogCompany: null,
      confirmBtnLoading: false,
      hasError: false,
      errors: [],
      processing: false
    }
  },
  computed: {
    ...mapState('app', ['company']),
    ...mapState('groups', ['group']),
    csvDialogGroup () {
      return this.group.children.map((e, i) => {
        return {
          type: e.type,
          text: e.name,
          value: e.id
        }
      })
    }
  },
  watch: {
    confirmBtnLoading (v) {
      this.processing = false
      if (v) {
        setTimeout(() => {
          this.processing = !!this.confirmBtnLoading
        }, 3000)
      }
    }
  },
  methods: {
    ...mapActions('customers', ['updateCsvProgress']),
    onFileChanged (e) {
      const fileChosen = e.target.files[0]
      if (fileChosen) {
        if (typeof (fileChosen.name) === 'string') {
          this.file = fileChosen
        }
      }
    },
    async sendFileHandler () {
      if (this.file === null) { return }

      this.confirmBtnLoading = true

      const id = this.company.id === 1
        ? this.csvDialogCompany
        : this.company.id

      try {
        const result = this.dialogText === '顧客CSV取込み'
          ? await api.uploadCustomerCsv(this.file, id)
          : await api.uploadSupplyCsv(this.file, id)

        if (result && result.uploadResultNumber) {
          this.updateCsvProgress({
            groupId: id,
            processId: result.uploadResultNumber
          })
        } else {
          this.$store.commit('app/setGlobalSnackBarText', '顧客情報を送信しました。（反映に時間がかかることがあります）')
        }

        this.csvUploadDialogCloseHandler()
      } catch (e) {
        if (e.status === 400) {
          if (e.response?.body?.errors) this.errors = e.response.body.errors
        }
      } finally {
        this.confirmBtnLoading = false
      }
    },
    csvUploadDialogCloseHandler (e) {
      this.$emit('closeDialog')
      this.$refs.file.value = null
      this.file = null
      this.csvDialogCompany = null
      if (this.errors.length) {
        this.errors = []
        this.hasError = false
      }
    },
    toggleErrorContainer () {
      this.hasError = !this.hasError
    }
  }
}
</script>

<style lang="scss" scoped>
.dialogHeader{
  margin: 0 0 15px 0;
  font-size: 1.5rem;
}
.error-header {
  font-size: 0.8rem;
  .down-icon {
    transition: transform 0.2s !important;
    cursor: pointer;
  }
  &:hover .down-icon {
    transform: translateY(-2px);
  }
  &:active .down-icon {
    transform: translateY(0);
  }
}
.error-container {
  visibility: hidden;
  transition: height 0.3s, transform 0.3s;
  height: 0;
  transform: scaleY(0);
  transform-origin: top;
  border: 1px solid red;
  font-size: 0.8rem;

  &-toggled {
    margin-top: 15px;
    overflow-y: scroll;
    visibility: visible;
    height: 6rem;
    transform: scaleY(1);
  }
}
.processing {
  position: absolute;
  right: 24px;
  font-size: 0.8rem;
  bottom: -5px;
  color: #333;
  opacity: 0;
  transition: opacity 1s ease-in;

  &.visible {
    opacity: 1;
    animation: blink 1.4s ease-in 1.4s infinite alternate;
  }
}
@keyframes blink {
  from {
    opacity: 1;
  }
  to {
    opacity: 0.25;
  }
}
</style>
